import { useContext, useEffect, useState } from "react";
import "../../../styles/style.css";
import { useLocation } from "react-router";
import { pricingPlanTabContext, pricingPlanCurrentTabContext } from "../context/pricing_plan_context";

const PricingPlanTab = () => {
  const { tabs } = useContext(pricingPlanTabContext);
  const location = useLocation();
  const { currentTab, setTab, setTabByValue } = useContext(pricingPlanCurrentTabContext);
  const [isMobile, setIsMobile] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Mobile detection
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (location.state && location.state.invoicePlanSyscode !== undefined && location.state.invoiceSyscode !== undefined) {
      setTabByValue(location.state.invoicePlanSyscode, location.state.invoiceSyscode)
    }
  }, []);

  const handleTabClick = (tab) => {
    setTab(tab);
    if (isMobile) {
      setIsDropdownOpen(false);
    }
  };

  // Mobile dropdown version
  if (isMobile) {
    return (
      <div className="pb-4 relative">
        {/* Mobile dropdown button */}
        <button
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          className="w-full bg-white border border-gray-300 rounded-md px-4 py-3 text-left shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          aria-expanded={isDropdownOpen}
          aria-haspopup="true"
        >
          <div className="flex items-center justify-between">
            <span className="font-medium text-gray-900 text-base">
              {currentTab.name}
            </span>
            <svg
              className={`w-5 h-5 text-gray-400 transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''
                }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </button>

        {/* Mobile dropdown menu */}
        {isDropdownOpen && (
          <>
            {/* Backdrop */}
            <div
              className="fixed inset-0 z-10"
              onClick={() => setIsDropdownOpen(false)}
            />

            {/* Dropdown content */}
            <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded-md shadow-lg z-20 max-h-60 overflow-auto">
              {tabs.map((tab) => (
                <button
                  key={tab.name}
                  onClick={() => handleTabClick(tab)}
                  className={`pricing-plans-dropdown-item ${tab.name === currentTab.name ? "active" : "inactive"
                    }`}
                >
                  {tab.name}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    );
  }

  // Desktop horizontal tabs version
  return (
    <div className="sm:block pb-4">
      <nav className="flex space-x-4 overflow-x-auto" aria-label="Tabs">
        {tabs.map((tab) => (
          <button
            key={tab.name}
            onClick={() => handleTabClick(tab)}
            className={`pricing-plans-tab ${tab.name === currentTab.name ? "active" : "inactive"
              }`}
            aria-current={tab.name === currentTab.name ? "page" : undefined}
          >
            {tab.name}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default PricingPlanTab;